import axios from 'axios';
import router from '../router';

const baseURL = `${process.env.VUE_APP_API_BASE_URL}/courses/${window.courseId}/members`;

const config = {
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

const authRedirect = () => {
  localStorage.removeItem('jwtToken');
  router.push('/login');
};

const Http = axios.create(config);

Http.interceptors.response.use(response => response, (error) => {
  switch (error.response.status) {
    case 401:
    case 403:
    case 404:
      authRedirect();
      break;
    default: break;
  }
  return Promise.reject(error);
});

export default Http;
